const $ = window.jQuery;

import Router from "./app/router";
import MainView from "./app/view.main";
import Store from "./app/store";
import MobileMenuView from "./app/view.mobile-menu";

class App {
    constructor() {
        this.store = new Store();
        this.mainView = new MainView($("#container"), this.store);
        this.router = new Router(this.store);
        new MobileMenuView(".burger-menu");

        this.initNavigation();

        this.comingBackFromOverlay = false;
    }

    initNavigation() {
        this.store.on("router:main-route-fired", () => this.mainRouteHandler());
        this.store.on("router:forward-link-clicked", (evtData) =>
            this.forwardLinkClickedHandler(evtData),
        );
        this.store.on("pageLoaded", (evtData) =>
            this.pageLoadedHandler(evtData),
        );
    }

    forwardLinkClickedHandler(evtData) {
        this.store.updateFragment(evtData.href, "scrollTop", 0);
    }

    mainRouteHandler() {
        $("html").addClass("is-loading").removeClass("show-off-canvas");

        var url = window.location.href;

        this.store.loadPage(url, {
            useCache: !globals.booleans.isLoggedIn,
        });
    }

    pageLoadedHandler(evtData) {
        this.store.detectNavigationDirection();

        let data = evtData.data;

        this.mainView.render(data);

        this.comingBackFromOverlay = false;
    }
}

$(document).ready(function () {
    setTimeout(function () {
        new App();
    }, 100);
});
